import Alpine from "alpinejs";

export type ViewportStore = {
    x: number;
    y: number;
    scale: number;
};

Alpine.store('viewport', {
    x: 0,
    y: 0,
    scale: 1,
} satisfies ViewportStore);
